import { render, staticRenderFns } from "./Sketches.vue?vue&type=template&id=72c66a2a&scoped=true"
import script from "./Sketches.vue?vue&type=script&lang=js"
export * from "./Sketches.vue?vue&type=script&lang=js"
import style0 from "./Sketches.vue?vue&type=style&index=0&id=72c66a2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c66a2a",
  null
  
)

export default component.exports